export default "__VITE_ASSET__66f7117a__"